<div class="post-source-header" *ngIf="post">
  <button *ngIf="canChooseAuthorDestination; else postedByAvatar"
     pButton type="button"
     class="p-button-text p-button-plain p-0 post-source-header__avatar post-source-header__author-button"
     [attr.aria-label]="('shared.modal.modal_service.avatar_actions.navigation_title' | translate) + ': ' + post.postedBy.username"
     aria-haspopup="dialog"
     (click)="openAuthorChoice($event)">
    <app-thumbnail classList="thumbnail-inline-block"
                   size="md"
                   [circle]="true"
                   [imgSrc]="post.postedBy.avatar | mediaObject">
    </app-thumbnail>
  </button>
  <ng-template #postedByAvatar>
    <app-thumbnail class="post-source-header__avatar"
                   classList="thumbnail-inline-block"
                   size="md"
                   [circle]="true"
                   [imgSrc]="post.postedBy?.avatar | mediaObject">
    </app-thumbnail>
  </ng-template>

  <div class="post-source-header__meta">
    <div class="post-source-header__author-line">
      <button *ngIf="canChooseAuthorDestination; else postedByName"
         pButton type="button"
         class="p-button-text p-button-plain p-0 post-source-header__author post-source-header__author-button"
         aria-haspopup="dialog"
         (click)="openAuthorChoice($event)">
        {{ post.postedBy.username }}
      </button>
      <ng-template #postedByName>
        <span class="post-source-header__author">{{ post.postedBy?.username }}</span>
      </ng-template>
      <span *ngIf="showShareState" class="post-source-header__share-suffix">{{ 'shared.share.root_state_suffix' | translate }}</span>
      <i *ngIf="hasVideoMedia && !hasResourceTarget" class="pi pi-play ml-1" aria-hidden="true"></i>
    </div>

    <div *ngIf="hasResourceTarget" class="post-source-header__target">
      <ng-container [ngSwitch]="post.type">
        <ng-container *ngSwitchCase="PostTypeEnum.PROJECT_POST">
          <a [routerLink]="post.postedBy?.slug ? ['/' + post.postedBy.slug, 'garage', post.project.slug] : ['/garage', post.project.slug]"
             (click)="onResourceLinkClick($event)">
            <i class="pi pr-1" [ngClass]="hasVideoMedia ? 'pi-play' : 'pi-car'" aria-hidden="true"></i>
            <ng-container *ngIf="post.project.alias && post.project.vehicle?.fullVehicleIdentity">{{ post.project.alias }} |</ng-container>
            {{ projectTargetLabel }}
          </a>
        </ng-container>

        <ng-container *ngSwitchCase="PostTypeEnum.PROJECT_MEDIA_POST">
          <a [routerLink]="post.postedBy?.slug ? ['/' + post.postedBy.slug, 'garage', post.project.slug] : ['/garage', post.project.slug]"
             (click)="onResourceLinkClick($event)">
            <i class="pi pr-1" [ngClass]="hasVideoMedia ? 'pi-play' : 'pi-image'" aria-hidden="true"></i>
            <ng-container *ngIf="post.project.alias && post.project.vehicle?.fullVehicleIdentity">{{ post.project.alias }} |</ng-container>
            {{ projectTargetLabel }}
          </a>
        </ng-container>

        <ng-container *ngSwitchCase="PostTypeEnum.EVENT_DISCUSSION_POST">
          <a [routerLink]="['/events', post.event.slug, EventShowTabsEnum.DISCUSSION]"
             (click)="onResourceLinkClick($event)">
            <i class="pi pr-1" [ngClass]="hasVideoMedia ? 'pi-play' : 'pi-calendar-plus'" aria-hidden="true"></i>
            {{ post.event.name }}
          </a>
        </ng-container>
        <ng-container *ngSwitchCase="PostTypeEnum.COLLABORATION_MEDIA_POST">
          <a [routerLink]="['/', post.collaboration.owner?.slug || post.postedBy?.slug, 'collaborations', post.collaboration.slug || post.collaboration.id]"
             (click)="onResourceLinkClick($event)">
            <i class="pi pr-1" [ngClass]="hasVideoMedia ? 'pi-play' : 'pi-images'" aria-hidden="true"></i>
            {{ post.collaboration.title || collaborationProjectTargetLabel }}
          </a>
        </ng-container>
      </ng-container>
    </div>

    <span class="post-source-header__date">{{ post.createdAt | dateAgo }}</span>
  </div>
</div>

<p-dialog *ngIf="authorChoiceMounted"
          [(visible)]="authorChoiceVisible"
          [modal]="true"
          appendTo="body"
          [draggable]="false"
          [resizable]="false"
          [dismissableMask]="true"
          [closeOnEscape]="false"
          [style]="{width: 'min(32.5rem, 90vw)'}"
          [header]="'shared.modal.modal_service.avatar_actions.navigation_title' | translate"
          (onHide)="onAuthorChoiceHidden()">
  <app-avatar-actions [data]="{secondaryAction: 'garage'}"
                      (actionSelected)="chooseAuthorDestination($event)">
  </app-avatar-actions>
</p-dialog>
